var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1WHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair4_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M444.7,31.7c-4.5-2.5-9.1-4.8-13.8-6.9c-23.4-10.5-48.9-16.2-74.5-17c-1.5-0.1-3.1-0.1-4.6-0.1 c-2.9,0.1-5.9,0.2-8.8,0.4c-35.7,2.5-81.7,12.7-108.4,39.1c-7.4,6.3-13.9,13.4-19.6,21c-3.2,4.3-6.2,8.9-8.9,13.5 c-22.5,38.6-34.9,89.6-14,130.1c2.1,6.6,7.1,12.9,12.5,18c1.7,1.7,3.4,3.3,5.3,4.6c3.4,2.8,6.6,4.9,8.9,6.2 c4.5,2.7,11.9,5.9,15.6,6.6c-2.7-5.3-4.7-15.6,1.7-19.4c-2.1-1.1-2.2-8.8,0.3-13.2c3.4-7.5,10.9-16.4,17.2-22.7 c7.2-7.3,15.3-13.7,24-19.1c17.1-11.4,35.6-17,54.5-18.7c4.7-0.4,9.5-0.6,14.2-0.6c16.9,0.3,33.1,3.5,49.1,8 c5.3,1.5,10.6,3.1,15.8,4.9c33.1,7.7,77.1,47.5,104.5,13.4C543.7,122.5,494.1,59.3,444.7,31.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_4_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M492.6,198.9l-0.7-16.1c-1.1-14.7-0.5-17.3-6.7-19.5c-1.2-0.4-2.3-0.8-3.5-1.2 c-17.4-5.8-35.5-10-53.9-12.7c-3.3-0.5-6.6-0.9-9.9-1.4c-27-4.5-54.7-6.6-82.7-5.7c-3.5,0.1-7,0.3-10.5,0.5 c-30.5,2-60.7,7.2-88.4,17.8c-1.3,0.5-2.6,1-3.9,1.5c-2.8,1.1-10.1-0.1-4.5,45l0.1,3.2c1.3,9,5.6,10.6,10,9.1 c0.3-0.1,0.7-0.2,1-0.3c1.9-0.6,3.7-1.2,5.6-1.7c13.7-3.9,27.7-6.9,41.9-9c7.1-1.1,14.3-1.9,21.5-2.6c34-2.8,67.7-2.8,100.9,0.5 c6.6,0.6,13.2,1.4,19.8,2.4c12.9,1.9,25.6,4.6,38.1,7.9C479.8,220.3,494.2,227.1,492.6,198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M335.2,142.4c28-0.9,55.7,1.2,82.7,5.7c3.3,0.4,6.6,0.9,9.9,1.4c18.4,2.8,36.6,7,53.9,12.7 c0.1-2.5,0.2-4.9,0.1-7.4c-0.1-3.1-0.3-6.2-0.7-9.3c-2.8-22.6-13.8-46.3-33.2-62.4c-2.8-2.3-5.7-4.5-8.8-6.4 c-16.4-10.9-36.3-15.3-56.9-16.4c-3.4-0.2-6.9-0.3-10.3-0.3c-36.4,0.4-76.7,4.1-104,26.9c-2.9,2.2-5.5,4.6-8,7.1 c-18.1,18.3-24.9,42.7-23.7,66.9c27.7-10.6,57.9-15.8,88.4-17.8C328.2,142.7,331.7,142.5,335.2,142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M477.2,157.9c-2.4-1-4.8-1.9-7.2-2.9c-16.1-6.1-32.9-11-50.1-14.8c-3.4-0.8-6.9-1.5-10.4-2.1 c-38.2-7.3-77.3-8.3-115.9-4c-3.5,0.4-7,0.9-10.4,1.4c-6.9,1.1-13.6,2.5-20.2,4.3c3.3-29.4,21.5-57.2,49.5-74 c0.1-0.1,0.3-0.2,0.4-0.2c-16.7,3.9-32.3,10.4-45.1,21.1c-2.9,2.2-5.5,4.6-8,7.1c-18.1,18.3-24.9,42.7-23.7,66.9 c27.7-10.6,57.9-15.8,88.4-17.8c3.5-0.2,7-0.4,10.5-0.5c28-0.9,55.7,1.2,82.7,5.7c3.3,0.4,6.6,0.9,9.9,1.4 c18.4,2.8,36.6,7,53.9,12.7c0.1-0.8,0.1-1.6,0.1-2.4C480.2,159.2,478.8,158.6,477.2,157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M254.4,196.8c6.4-13.6,13.8-27.8,7.7-44.2c-8.8,2.3-17.5,5-25.9,8.2c-1.3,0.5-2.6,1-3.9,1.5 c-2.8,1.1-10.1-0.1-4.5,45l0.1,3.2c1.3,9,5.6,10.6,10,9.1c0.3-0.1,0.7-0.2,1-0.3c1.9-0.6,3.7-1.2,5.6-1.7c4.6-1.3,9.3-2.5,14-3.7 C255.9,208.2,252.4,202,254.4,196.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M362.7,50c-11.2-6-24.2,1.6-26.4,11.7c10.7-1.2,21.6-1.7,32.1-1.9C367.8,56.2,366.7,52.1,362.7,50z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M323.9,146c3.5-0.2,7-0.4,10.5-0.5c28-0.9,55.7,1.2,82.7,5.7c3.3,0.4,6.6,0.9,9.9,1.4 c21.9,3.3,43.3,8.5,63.5,16.1c-0.8-2.9-2.1-4.2-5.3-5.3c-1.2-0.4-2.3-0.8-3.5-1.2c-6.4-2.1-12.9-4-19.5-5.7l-0.3-6.8 C458.3,120,446.3,95,423,73.8c23.1,21.5,33,47,36.3,76l0.3,6c-10.4-2.6-21-4.7-31.7-6.3l-0.7-6.3c-4-28.3-13.8-51.6-29.8-75.7 c15.8,24.3,23.4,48,27.3,75.9l0.6,5.7c-2.5-0.4-4.9-0.7-7.4-1c-9.4-1.6-18.8-2.8-28.4-3.8l-0.3-5.8c-1.6-26-3.2-48.7-12.9-73 c9.4,24.5,8.9,47,10.3,73.1l0.3,5.5c-9.8-0.9-19.7-1.5-29.6-1.7v-5.6c-0.2-25-2.5-46.2-6.5-70.4c3.7,24.2,3.9,45.5,3.9,70.4v5.5 c-6.5-0.1-13-0.1-19.5,0.1c-3.5,0.1-7,0.3-10.5,0.5c-1.4,0.1-2.7,0.2-4.1,0.3l-0.4-5c-1.8-24.7-2-46.6,8.5-69.6 c-10.8,22.8-12.7,44.8-11,69.8c0.1,1.7,0.3,3.4,0.4,5.1c-10.8,0.9-21.5,2.2-32.1,4c-0.3-1.6-0.6-3.2-0.8-4.9 c-2.5-23.1,0.7-43.6,10.7-65c-10.3,21.2-15.7,41.5-13.2,65.2c0.2,1.7,0.5,3.4,0.8,5.1c-7.2,1.3-14.3,2.8-21.3,4.6 c-0.2-1.4-0.4-2.9-0.5-4.3c-1.6-21.3,2.3-39.8,9.7-59.8c-7.8,19.9-13.8,38.1-12.3,60c0.1,1.6,0.4,3.2,0.6,4.8 c-8,2.1-15.8,4.6-23.4,7.6c-1.3,0.5-2.6,1-3.9,1.5c-1.3,0.5-3.6,0.6-5.1,4.9c3-1.3,6-2.5,9.1-3.7 C263.8,153.1,293.7,148,323.9,146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M409.4,202.7c-33.2-3.3-67-3.3-100.9-0.5c-7.2,0.7-14.4,1.6-21.5,2.6c-14.2,2.1-28.2,5.1-41.9,9 c-2.2,0.6-4.4,1.3-6.6,2.1c-2.4,0.8-4.7,1.7-7.1,2.6c1.9,1.8,4.3,1.9,6.7,1.1c0.3-0.1,0.7-0.2,1-0.3c1.9-0.6,3.7-1.2,5.6-1.7 c13.7-3.9,27.7-6.9,41.9-9c7.1-1.1,14.3-1.9,21.5-2.6c34-2.8,67.7-2.8,100.9,0.5c6.6,0.6,13.2,1.4,19.8,2.4 c12.9,1.9,25.6,4.6,38.1,7.9c7.2,1.9,14.8,4.9,19.9,2.3c-18.5-6.4-37.9-11-57.6-14C422.6,204.1,416,203.3,409.4,202.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M253.9,208.9c-6.7-15.5-5.5-29.6-4.6-45c-0.4,15.6,1.6,29.3,8.1,43.9l1.8,3.9l-3.4,1.4L253.9,208.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M278.5,203.7c-5.4-15.8-6.4-30-4.1-45.7c-1.7,15.8,2.4,29.6,7.8,44.7c0.5,1.4,1.1,2.7,1.7,4l-3.5,1.2 C279.7,206.5,279,205.1,278.5,203.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M306.9,200c-3.8-16.1-5.3-30.1-4.6-46.1c-0.1,16,4.4,29.6,8.3,45.4l1.1,4.2l-3.7,0.7L306.9,200z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M338,197.9c-3.2-16.5-1.4-30.8,1-46.7c-1.9,16-0.6,30.1,2.7,46.1l0.9,4.3l-3.7,0.7L338,197.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M370.3,197.5c2.8-16.4,5-30.5,3.1-46.8c2.5,16.1,3.3,30.6,0.7,47.3l-0.8,4.4l-3.7-0.5L370.3,197.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M406,200.1c3.9-15.9,5.8-30.2,2.3-46.3c4,15.8,5.3,30.4,1.4,47l-1.2,4.4l-3.6-0.8L406,200.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M440.9,205.2c2.6-15.2,3.9-28.7,0.6-43.8c3.7,14.9,5.6,28.6,3.1,44.3l-0.8,4.2l-3.7-0.6L440.9,205.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M466.2,210.1c3.5-14.8,6.2-27.7,4.8-42.7c1.9,14.8,2.3,28.1-1.1,43.3l-1.1,4l-3.7-0.8L466.2,210.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M315.3,72.7c-0.3,1.5-1.3,2.6-2.2,2.5c-0.9-0.1-1.3-1.5-1-3s1.3-2.6,2.2-2.5 C315.2,69.9,315.7,71.2,315.3,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M306.5,95.4c-0.3,1.2-1.1,2.2-1.8,2c-0.7-0.1-1.1-1.2-0.8-2.5c0.3-1.2,1.1-2.2,1.8-2 S306.8,94.2,306.5,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M272.4,122.8c-0.3,1.2-1.1,2.2-1.8,2c-0.7-0.1-1.1-1.2-0.8-2.5c0.3-1.2,1.1-2.2,1.8-2 C272.3,120.4,272.7,121.5,272.4,122.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M267.2,195.6c0,1.3-0.5,2.3-1.3,2.3c-0.7,0-1.4-1-1.4-2.3s0.5-2.3,1.3-2.3 C266.5,193.4,267.1,194.4,267.2,195.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M293.8,157.6c0,1.5-0.6,2.8-1.5,2.8s-1.6-1.2-1.7-2.7c0-1.5,0.6-2.8,1.5-2.8 C293,154.9,293.8,156.1,293.8,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M291.4,193.3c0.4,1.5,0,2.8-0.9,3s-1.9-0.9-2.2-2.4c-0.4-1.5,0-2.8,0.9-3 C290,190.8,291,191.8,291.4,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M320.5,176.2c0.3,1.5-0.2,2.8-1.1,2.9c-0.9,0.1-1.8-1-2.1-2.5c-0.3-1.5,0.2-2.8,1.1-2.9 S320.2,174.7,320.5,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M330.6,152.1c0,1.5-0.8,2.7-1.7,2.7c-0.9,0-1.6-1.2-1.5-2.8c0-1.5,0.8-2.7,1.7-2.7 C329.9,149.4,330.6,150.6,330.6,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M355.9,155.4c0,1.5-0.8,2.7-1.7,2.7c-0.9,0-1.6-1.2-1.5-2.8c0-1.5,0.8-2.7,1.7-2.7 C355.2,152.6,355.9,153.8,355.9,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M351.8,190.1c0,1.5-0.8,2.7-1.7,2.7c-0.9,0-1.6-1.2-1.5-2.8c0-1.5,0.8-2.7,1.7-2.7 C351.1,187.4,351.8,188.6,351.8,190.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M389.9,166.3c0,1.5-0.8,2.7-1.7,2.7c-0.9,0-1.6-1.2-1.5-2.8c0-1.5,0.8-2.7,1.7-2.7 C389.2,163.5,389.9,164.7,389.9,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M394,192.6c-0.2,1.5-1.1,2.6-2,2.5s-1.4-1.4-1.2-2.9c0.2-1.5,1.1-2.6,2-2.5 C393.7,189.8,394.2,191.1,394,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M430.7,187.1c-0.2,1.5-1.1,2.6-2,2.5s-1.4-1.4-1.2-2.9c0.2-1.5,1.1-2.6,2-2.5 C430.4,184.3,430.9,185.6,430.7,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M456,171.1c0,1.5-0.7,2.7-1.6,2.7s-1.6-1.2-1.6-2.7s0.7-2.7,1.6-2.7C455.3,168.4,456,169.6,456,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M458.2,201.1c-0.1,1.5-0.9,2.7-1.8,2.6c-0.9-0.1-1.5-1.3-1.4-2.8s0.9-2.7,1.8-2.6 C457.7,198.3,458.3,199.6,458.2,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M482,174.1c0,1.9-0.9,3.4-2,3.4s-2-1.5-2-3.4s0.9-3.4,2-3.4C481.1,170.7,482,172.2,482,174.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M299.3,122.3c-0.2,1.3-1,2.3-1.8,2.2c-0.8-0.1-1.2-1.2-1-2.6c0.2-1.3,1-2.3,1.8-2.2 C299.1,119.8,299.6,120.9,299.3,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M281.5,87.6c-0.7,1.6-2.1,2.6-3,2.3c-0.9-0.3-1.1-1.8-0.3-3.4c0.7-1.6,2.1-2.6,3-2.3 C282.1,84.4,282.2,86,281.5,87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M254.9,121.8c-0.5,1.6-1.6,2.8-2.6,2.6c-1-0.2-1.4-1.7-0.9-3.3c0.5-1.6,1.6-2.8,2.6-2.6 C254.9,118.7,255.3,120.2,254.9,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M247.7,143c-0.1,1.7-0.9,3-1.9,3s-1.8-1.4-1.7-3.1c0.1-1.7,0.9-3,1.9-3S247.7,141.3,247.7,143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M238.6,188c-0.1,1.7-0.9,3-1.9,3s-1.8-1.4-1.7-3.1c0.1-1.7,0.9-3.1,1.9-3 C237.9,184.9,238.7,186.3,238.6,188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M261.5,171.9c-0.1,1.5-0.8,2.8-1.7,2.7c-0.9,0-1.6-1.3-1.5-2.8c0-1.5,0.8-2.8,1.7-2.7 C260.8,169.1,261.5,170.4,261.5,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M239.2,209.9c0.3,1.3-0.1,2.5-0.8,2.6s-1.6-0.8-1.9-2.2c-0.3-1.3,0.1-2.5,0.8-2.6 S238.9,208.6,239.2,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M335.7,86.7c0,1.3-0.6,2.4-1.4,2.4s-1.5-1.1-1.5-2.4s0.6-2.4,1.4-2.4C335,84.3,335.7,85.3,335.7,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M333.7,122.3c0,1.3-0.7,2.4-1.5,2.4s-1.4-1.1-1.4-2.4s0.7-2.4,1.5-2.4 C333.1,119.8,333.7,120.9,333.7,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M366.7,85c0,1.3-0.7,2.4-1.5,2.4s-1.4-1.1-1.4-2.4s0.7-2.4,1.5-2.4S366.7,83.7,366.7,85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M369.6,105.4c0,1.3-0.7,2.4-1.5,2.4s-1.4-1.1-1.4-2.4s0.7-2.4,1.5-2.4S369.6,104.1,369.6,105.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M394.6,83c0.2,1.3-0.3,2.5-1.1,2.6c-0.8,0.1-1.6-0.9-1.8-2.2c-0.2-1.3,0.3-2.5,1.1-2.6 C393.6,80.6,394.4,81.6,394.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M402.4,123.6c0.2,1.3-0.3,2.5-1.1,2.6c-0.8,0.1-1.6-0.9-1.8-2.2c-0.2-1.3,0.3-2.5,1.1-2.6 C401.4,121.3,402.2,122.3,402.4,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M428,99.5c0.4,1.3,0.1,2.5-0.6,2.7c-0.8,0.2-1.7-0.7-2.2-2c-0.4-1.3-0.1-2.5,0.6-2.7 C426.6,97.3,427.5,98.2,428,99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M443,130.9c0.4,1.3,0.1,2.5-0.7,2.6c-0.8,0.2-1.7-0.7-2.1-2s-0.1-2.5,0.7-2.6 C441.7,128.7,442.7,129.6,443,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M462.4,111c0.4,1.3,0.1,2.5-0.7,2.6c-0.8,0.2-1.7-0.7-2.1-2s-0.1-2.5,0.7-2.6 C461.1,108.8,462.1,109.7,462.4,111z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1WHair4);
export default __webpack_public_path__ + "static/media/m-hat1_w-hair4.13d048e56a43aa981bcd3ed4758154e2.svg";
export { ForwardRef as ReactComponent };